 let config;
export default config = {
  localhost: {
    Character: '0x435a7dC45750582E587fAbcC989C9500599A7824',
    McStake: '0x6035CA63bA37442a2FeAC6Dc43fb87c5a8CC3969',
    FastFood: '0x3c360fa344a4E0724E8807C48b1e6e7a24aE51d2',
    CasualFood: '0x881fdE7F7fa44E5038f3A1dbd41CD3F90738F347',
    GourmetFood: '0x3bff548dd910935DCfbC83681eDB4252925cF2ce',
    Gym: '0x3B87b2A62760AF2e583b06c98Df54b710f38f71c',
    Mint: '0x34D1B91752730f957A46c30248279198eA5b2256',
    KitchenShop: '0x9C95F62797e11C68E5611d0D21eC49c3a89604bE',
    KitchenUsage: '0x4CB057a173F0E87D0aF8A78B396F93C8244943F6',
    TheStakeHouse: '0x83B66Eb934ddD4C0E8C37FF0916E3A7E90Cd0181',
    LeStake: '0x02d2cA99CEB0d3Da1453fd808C56BFB79837Fdf6',
    Claim: '0x61b9BC212ad93365dc3C198f350f9d66da79D023',
    Paywall: '0x282ee709621cE43e2F2Ec019700F51F089f30fF0',
    Config: '0xC6aE929bCA4c8914738E3675eEd998be8fB2b4aF',
    TripleFiveClub: '0x0eA723f65b279a85754fc3b1C1dfb8b025A23E8c',
    admin: ['0x2f7CdD90AB83405654eE10FC916a582a3cDe7E69', '0xf2886eeDD665b67D6D2dF64f422152081bE53292'],
    loggedIn: {
      gourmetKitchenClosed: true,
      fastFoodKitchenClosed: false,
      casualKitchenClosed: true,
      casualClosedSign: false,
      casualBuyButton: true,
      gourmetBuyButton: true,
      gourmetClosedSign: false,
      fastfoodClosedSign: false,
      casualForSaleSign: true,
      gourmetForSaleSign: true,
      fastfoodForSaleSign: false,
    },
    loggedOut: {
      gourmetKitchenClosed: true,
      fastFoodKitchenClosed: true,
      casualKitchenClosed: true,
      casualClosedSign: true,
      gourmetClosedSign: true,
      fastfoodClosedSign: true,
      casualForSaleSign: false,
      gourmetForSaleSign: false,
      fastfoodForSaleSign: false,
      casualBuyButton: false,
      gourmetBuyButton: false,
    }

  },
  mainnet: {
    ChefRat: '0xB37518b874F606bbcbfC3049fe2Efe0f81129c07',
    KitchenPack: '0xC6aE929bCA4c8914738E3675eEd998be8fB2b4aF',
    FastFood: '0xB09F74A9969e8AAFECe79558Cf02bCB7f8398de1',
  },
  beta: {
    Character: '0xb3f79FBBbb478782Eb3BeB6B1121A9664f9303a4',
    McStake: '0xb813ceCFCC8C2d726b0D81afE20622b28F65dC73',
    FastFood: '0x64B5Ba6adbedaac0093803996eFebd211a60813f',
    CasualFood: '0x41AAeb2397a48624877CcDF695D734c5C49078a7',
    GourmetFood: '0xa9A49Af3488631Ea0C22FE8c3687Cc562925EccF',
    Gym: '0x86AD6Ee5Dd049490E22f7496803eAe019b75953A',
    Mint: '0x476C0ADE754a40a8cDE1f48bF277e7a993fAc162',
    KitchenShop: '0xcFD889e6208C246225a490E94178feBC0B66010B',
    KitchenUsage: '0x180535594CEb0f57Db257bcDd5989036452Ea2a5',
    TheStakeHouse: '0xF3676f225b02ADD6340fB267998c2c29136B0968',
    LeStake: '0x4Cc6FC2261F2922735EE59f875690F76F96568CE',
    Claim: '0xDE72f8c21f86eB6C7736992CB0AB825F07c7FAdA',
    Paywall: '0x2bC78051F66b399E5eFaDFE71A98d8f52c3C94Af',
    Config: '0x3893a6e03F7339d87bc66692b05C67360235772e',
    admin: ['0x2f7CdD90AB83405654eE10FC916a582a3cDe7E69', '0xf2886eeDD665b67D6D2dF64f422152081bE53292'],
    loggedIn: {
      gourmetKitchenClosed: true,
      fastFoodKitchenClosed: false,
      casualKitchenClosed: true,
      casualClosedSign: false,
      casualBuyButton: true,
      gourmetBuyButton: true,
      gourmetClosedSign: false,
      fastfoodClosedSign: false,
      casualForSaleSign: true,
      gourmetForSaleSign: true,
      fastfoodForSaleSign: false,
    },
    loggedOut: {
      gourmetKitchenClosed: true,
      fastFoodKitchenClosed: true,
      casualKitchenClosed: true,
      casualClosedSign: true,
      gourmetClosedSign: true,
      fastfoodClosedSign: true,
      casualForSaleSign: false,
      gourmetForSaleSign: false,
      fastfoodForSaleSign: false,
      casualBuyButton: false,
      gourmetBuyButton: false,
    }
  },
  mumbai: {
    Character: '0xC6B66a9832271DE623CA73bf883469120A9208d2',
    McStake: '0x39e9F168B3c5d14b252d54d580F9D827C5417D97',
    FastFood: '0xd7dD896bE2DB99Db8665425f6815827d8fA53F02',
    CasualFood: '0xa986f1FDbF6d6df44e29f8EA253AFAdad71C9ccb',
    GourmetFood: '0x92827c8f25Cb8220c83F4E416a270883b31D7EA3',
    Gym: '0x429E093a16500C9C6C7EaAC0ebc16256930777c5',
    Mint: '0xEb0958278D5B815deC994C643AC831fcD85Fa9a0',
    KitchenShop: '0xb64B7d06Eeec6D65A5d7E5A66594b93768658119',
    KitchenUsage: '0xa729B4682f3C197330DD60a3bf595bE7AE77936B',
    TheStakeHouse: '0xB3b0C629f85c95cb684Ef6F975693E4E034885fa',
    LeStake: '0x35035d295006DfF9cCC5acB7E6bE886bB7195CAC',
    Claim: '0xBfe004e55d1131936edBbb306F7B1d641d088518',
    Paywall: '0xEA700a72b8FeAA0D49A73Daee789fFE86a510DC3',
    Config: '0xeA9759C546DfFBFb86F7B0bF0c50c29D9Be540ca',
    admin: ['0x2f7CdD90AB83405654eE10FC916a582a3cDe7E69', '0xf2886eeDD665b67D6D2dF64f422152081bE53292'],
    loggedIn: {
      gourmetKitchenClosed: true,
      fastFoodKitchenClosed: false,
      casualKitchenClosed: true,
      casualClosedSign: false,
      casualBuyButton: true,
      gourmetBuyButton: true,
      gourmetClosedSign: false,
      fastfoodClosedSign: false,
      casualForSaleSign: true,
      gourmetForSaleSign: true,
      fastfoodForSaleSign: false,
    },
    loggedOut: {
      gourmetKitchenClosed: true,
      fastFoodKitchenClosed: true,
      casualKitchenClosed: true,
      casualClosedSign: true,
      gourmetClosedSign: true,
      fastfoodClosedSign: true,
      casualForSaleSign: false,
      gourmetForSaleSign: false,
      fastfoodForSaleSign: false,
      casualBuyButton: false,
      gourmetBuyButton: false,
    }
  },
  matic: {
    Character: '0x3242CCF5d7f35BaB5A560e7ae2Fa64EfDCa9Cd1c',
    McStake: '0x6B9a151dE8E5EE719dC2fD307535EFBf3074aa89',
    FastFood: '0x2721d859EE8d03599F628522d30f14d516502944',
    CasualFood: '0x33CC3b1852939Ef8CFd77BB5c3707cF2D3E72490',
    GourmetFood: '0x57d43Cfe565A2e6C181662aE73A9F1EC6A830351',
    Gym: '0x7b7F4123e1b060dbB1F98136A57C5eC8ca5540dc',
    Mint: '0xB277BA92B92C6d1C186249f454E2Dd4433466e4F',
    KitchenShop: '0xa7f7b2aF7233b2107c41BEF3F1D3f7acd4d4576B',
    KitchenUsage: '0x20d6aa7eA4142592daeB2E3A312C62D6318B40B4',
    TheStakeHouse: '0x7e8F67232864f716a9E6f818F3b387828d934899',
    LeStake: '0x2BbF185118233D81AAf15AfdccCB34C6554334ea',
    Claim: '0xc7e50625c2268308C57386D04C5A8f8ae8f6E136',
    Paywall: '0x4a0CA9aB63f4892DDBd2E2693c4DDba1B33afdFe',
    Config: '0xF7876C368AEe216f98b90Cf16c600926516c3337',
    TripleFiveClub: '0x3d06651Adb58bE764e91745f93C366748f4eB7a0',

//MainTest2
/*
    Character: '0xC6B66a9832271DE623CA73bf883469120A9208d2',
    McStake: '0x39e9F168B3c5d14b252d54d580F9D827C5417D97',
    FastFood: '0xd7dD896bE2DB99Db8665425f6815827d8fA53F02',
    CasualFood: '0xa986f1FDbF6d6df44e29f8EA253AFAdad71C9ccb',
    GourmetFood: '0x43A437bC921e2a139F7AF336f81EC6B1b7C0cb2E',
    Gym: '0x429E093a16500C9C6C7EaAC0ebc16256930777c5',
    Mint: '0xEb0958278D5B815deC994C643AC831fcD85Fa9a0',
    KitchenShop: '0xb64B7d06Eeec6D65A5d7E5A66594b93768658119',
    KitchenUsage: '0xa729B4682f3C197330DD60a3bf595bE7AE77936B',
    TheStakeHouse: '0xB3b0C629f85c95cb684Ef6F975693E4E034885fa',
    LeStake: '0x35035d295006DfF9cCC5acB7E6bE886bB7195CAC',
    Claim: '0xBfe004e55d1131936edBbb306F7B1d641d088518',
    Paywall: '0xEA700a72b8FeAA0D49A73Daee789fFE86a510DC3',
    Config: '0xeA9759C546DfFBFb86F7B0bF0c50c29D9Be540ca',
    TripleFiveClub: '0xaEA62F0DE7Df2836A70195A88c46Ebf84cB1c234',
*/
    admin: ['0xd470D5015689D2C4f7cB8EF13F6F75e662E0b53C', '0xf2886eeDD665b67D6D2dF64f422152081bE53292'],
    loggedIn: {
      gourmetKitchenClosed: true,
      fastFoodKitchenClosed: false,
      casualKitchenClosed: true,
      casualClosedSign: false,
      casualBuyButton: true,
      gourmetBuyButton: true,
      gourmetClosedSign: false,
      fastfoodClosedSign: false,
      casualForSaleSign: true,
      gourmetForSaleSign: true,
      fastfoodForSaleSign: false,
    },
    loggedOut: {
      gourmetKitchenClosed: true,
      fastFoodKitchenClosed: true,
      casualKitchenClosed: true,
      casualClosedSign: true,
      gourmetClosedSign: true,
      fastfoodClosedSign: true,
      casualForSaleSign: false,
      gourmetForSaleSign: false,
      fastfoodForSaleSign: false,
      casualBuyButton: false,
      gourmetBuyButton: false,
    }
  }
}
